import { useEffect, useState } from 'react';

export default function App() {
	console.log('WeatherComponent.js rendered');
  const goTo = (id) => {
    const el = document.getElementById(id);
    el.scrollIntoView({ behavior: 'smooth' });
    console.log('Going to:', id);
  }

	const [weatherData, setWeatherData] = useState(null);

	useEffect(() => {
		const fetchWeatherData = async () => {
			try {
				const response = await fetch(
					'https://api.open-meteo.com/v1/forecast?latitude=52.52&longitude=13.41&current=temperature_2m,wind_speed_10m&hourly=temperature_2m,relative_humidity_2m,wind_speed_10m'
				);
				const data = await response.json();
				setWeatherData(data);
				console.log('Weather data:', data);
			} catch (error) {
				console.error('Error fetching weather data:', error);
			}
		};

		fetchWeatherData();
	}, []);

	return (
		<div className="fixed left-4 bottom-4 space-y-3">
      <div className="w-container">
        <div className="w-scroll-container snap-y">
          <div id="hey" className="w-item">
            <p>Thu, 23 May</p>
            <h1>
              {weatherData ? weatherData.current.temperature_2m : 'Loading...'}
              {weatherData ? weatherData.current_units.temperature_2m : ''}
            </h1>
          </div>
          <div id="bey" className="w-item">
            <p className="text-xl">Another info</p>
          </div>
        </div>

				<div className="absolute right-2 top-0 bottom-0 flex flex-col items-center justify-center gap-1.5 w-3 ml-auto h-full">
					<div onClick={() => goTo('hey')} className="nav-dot" />
					<div onClick={() => goTo('bey')} className="nav-dot" />
				</div>
			</div>

			<div className="w-container">
        <div className="w-scroll-container snap-x flex flex-row">
          <div id="hey2" className="w-item">
            <p>Thu, 23 May</p>
            <h1>
              {weatherData ? weatherData.current.temperature_2m : 'Loading...'}
              {weatherData ? weatherData.current_units.temperature_2m : ''}
            </h1>
          </div>
          <div id="bey2" className="w-item">
            <p className="text-xl">Another info</p>
          </div>
        </div>

				<div className="absolute bottom-2 left-0 h-3 min-w-full flex justify-center items-center gap-1.5">
					<div onClick={() => goTo('hey2')} className="nav-dot" />
					<div onClick={() => goTo('bey2')} className="nav-dot" />
				</div>
			</div>
		</div>
	);
}
